import axios from 'axios';

export const updateNickName = (userID, token, nickname) => {
    return axios.post(`${process.env.REACT_APP_API_COMMON}updateaccount`,
        { userID, nickname: nickname },
        { headers: { Authorization: `Bearer ${token}` } });
};